const _ = require('./enum');
module.exports = {
  [_.MOTO]: { id: _.MOTO, label: 'MOTO - Offline mode' },
  [_.OTHER]: { id: _.OTHER, label: 'Other' },
};
